import infrastructureApi from "./InfrastructureApi";

export async function userLogout() {
    try {
        const { data } = await infrastructureApi.post(
            "/auth/logout"
        );

        return data;
    } catch {
        return {
            success: false,
            message: "network_error",
        };
    }
}